<template>
	<div class="eia-page-header">
		<eia-nav-bar></eia-nav-bar>
	</div>
</template>

<script>
export default {
	name: 'eia-page-header',
};
</script>

<style lang="scss" scoped>
.eia-page-header {

}
</style>
